import { Box, Flex, Stack, Text } from '@mantine/core';
import { FC } from 'react';
import { Select } from 'src/components/Form/Select';
import { Switch } from 'src/components/Form/Switch';
import { InputText } from 'src/components/Form/Text';
import { PageLoader } from 'src/components/PageLoader';
import { PageTitle } from 'src/components/PageTitle';
import { ThemeSelector } from 'src/features/interaction/common';
import { ActionFooter } from 'src/components/ActionFooter';
import { Form } from 'src/form';

import {
  FormData,
  useAddInteraction,
  useInteractionThemes,
} from './use-add-interaction';

const ThemeSelection = () => {
  const { themeOptions } = useInteractionThemes();

  if (!themeOptions.length) {
    return null;
  }

  return (
    <ThemeSelector
      name="selected_theme_id"
      label="Theme Selection"
      themeOptions={themeOptions}
    />
  );
};

export const AddInteraction: FC = () => {
  const {
    isAddPending,
    handleSubmit,
    handleCancel,
    initialValues,
    validate,
    isPending,
    interactionDictionaryOptions,
  } = useAddInteraction();

  if (isPending) {
    return <PageLoader visible={true} />;
  }

  return (
    <Form<FormData>
      initialValues={initialValues}
      validate={validate}
      onSubmit={handleSubmit}
    >
      <Flex
        direction="column"
        justify="space-between"
        style={{ height: '100%' }}
      >
        <Stack gap="lg">
          <PageTitle title="Add New Interaction" />

          <InputText
            name="name"
            label="Interaction Name"
            placeholder="Enter interaction name"
            maxLength={30}
          />
          
          <Select
            name="interaction_dictionary_id"
            label="Base Interaction Dictionary"
            placeholder="Select base interaction"
            data={interactionDictionaryOptions}
          />

          <Box>
            <Text fw={500} mb="sm">
              Settings
            </Text>
            <Stack gap="sm">
              <Switch label="With Leaderboard" name="with_leaderboard" />
              <Switch label="With PVO" name="with_pvo" />
              <Switch label="With PVO Form" name="with_pvo_form" />
            </Stack>
          </Box>

          <ThemeSelection />
        </Stack>

        <ActionFooter
          onCancel={handleCancel}
          submitButton="CREATE"
          isLoading={isAddPending}
        />
      </Flex>
    </Form>
  );
};
